import {
  List,
  Datagrid,
  TextField,
  EditButton,
  TopToolbar,
  CreateButton,
  FunctionField,
  // ExportButton,
  // TextInput,
  // DateField,
  ListProps,
  // BooleanField,
  // ReferenceField,
} from 'react-admin';
import { Card, CardContent, Button, Box, Chip } from '@mui/material';
import DeleteWithConfirmButton from "../../../components/DeleteWithConfirmButton.tsx";
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useNotify, useRedirect, useRefresh, useDataProvider } from 'react-admin';
import { BulkDeleteButton } from 'react-admin';

const CustomBulkActionButtons = () => (
  <>
    <BulkDeleteButton
      label="Delete Selected"

    />
  </>
);


const ListActions = () => {
  const refresh = useRefresh();
  const notify = useNotify();
  const redirect = useRedirect();
  const navigate = useNavigate();
  return (
    <TopToolbar sx={{ marginBottom: '16px', }}>



      <CreateButton label="New User" sx={{
        top: '-5px', '& span': {

          marginRight: '2px',
        }
      }} />
    </TopToolbar>
  );
};

const ActionButtons = ({ record }: { record?: any }) => {
  const navigate = useNavigate();
  if (!record) return null;
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px', width: '100%' }}>
      <EditButton record={record} sx={{
        textTransform: 'capitalize', '& span': {

          marginRight: '2px',

        }
      }} />
      <DeleteWithConfirmButton record={record} resource="permissionUsers" />
    </div>
  );
};



const UserList = (props: ListProps) => {
  const dataProvider = useDataProvider();
  const [departmentMap, setDepartmentMap] = useState<{ [key: string]: string }>({});
  const [roleMap, setRoleMap] = useState<{ [key: string]: string }>({});

  useEffect(() => {
    // 拉取部门
    dataProvider.getList('permissionDepartment', {
      pagination: { page: 1, perPage: 1000 },
      sort: { field: 'id', order: 'ASC' },
      filter: {}
    }).then(res => {
      const map: { [key: string]: string } = {};
      res.data.forEach((item: any) => {
        map[item.id] = item.departmentName;
      });
      setDepartmentMap(map);
    });
    // 拉取角色
    dataProvider.getList('permissionRoles', {
      pagination: { page: 1, perPage: 1000 },
      sort: { field: 'id', order: 'ASC' },
      filter: {}
    }).then(res => {
      const map: { [key: string]: string } = {};
      res.data.forEach((item: any) => {
        map[item.id] = item.roleName;
      });
      setRoleMap(map);
    });
  }, [dataProvider]);

  return (
    <List
      sx={{ marginTop: '20px', padding: '0 16px' }}
      empty={false}
      {...props} actions={<ListActions />}
    >
      <Datagrid
        rowClick={false}
        isRowSelectable={() => true}
        bulkActionButtons={<BulkDeleteButton label="Batch Delete" />}
        sx={{
          '& .RaDatagrid-headerCell': {
            textAlign: 'center',
          },
          '& .RaDatagrid-rowCell': {
            textAlign: 'center',
          },
        }}
      >
        <TextField source="id" label="User Id" />
        <TextField source="userName" label="User Name" />
        <TextField source="email" label="Mailbox" />
        <FunctionField
          label="Department"
          render={record => departmentMap[record.departmentId] || '-'}
        />
        <FunctionField
          label="Role"
          render={record => roleMap[record.roleId] || '-'}
        />
        <FunctionField
          label="Status"
          render={record =>
            record && record.isActive ? (
              <Chip label="Active" color="success" size="small" />
            ) : (
              <Chip label="Inactive" color="default" size="small" />
            )
          }
        />
        <FunctionField label="Operations" render={record => <ActionButtons record={record} />} />
      </Datagrid>
    </List>
  );
};

export default UserList;
